/**
 * Navigation state key marking the trip sign-in recovery makes back to the page the person was on
 * (`AuthService.navigateAfterLogin`). Read by {@link AuthGuard} when it refuses a page (#1722).
 *
 * Kept in its own file on purpose: importing it from `auth-guard.service.ts` pulls the guard's imports into
 * the start-up bundle through `AuthService`, adding about 360 kB and failing the production build's budget.
 */
export const RETURNING_AFTER_SIGN_IN = 'returningAfterSignIn';
